import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { injectIntl } from 'react-intl'
import ChartWrapper from 'components/Apps/EnvironmentMonitor/ChartWrapper'
import ListWrapper from 'components/Apps/EnvironmentMonitor/ListView'
import { TransparencyWhite } from 'helpers/customIcons'
import {
  CHART_TYPE_FORECAST,
  CHART_TYPE_HISTORICAL,
  TYPE_TRANSPARENCY,
} from 'helpers/environmentMonitor'
import {
  fetchHistoricalData,
  setListForecastData,
  fetchVisibilityData,
} from 'reducers/environmentMonitor/reducer'
import SensorForecastBar from 'components/Apps/EnvironmentMonitor/Charts/SensorForecastBar'
import SensorHistorical from 'components/Apps/EnvironmentMonitor/Charts/SensorHistorycal'
import messages from 'components/Apps/SlaMonitor/translate'

class Transparency extends Component {
  constructor(props) {
    super(props)
    this.state = {
      chartType: CHART_TYPE_FORECAST,
      datasetIndex: 1,
    }
  }

  componentList = {
    [`${CHART_TYPE_FORECAST}`]: SensorForecastBar,
    [`${CHART_TYPE_HISTORICAL}`]: SensorHistorical,
  }

  componentDidMount() {
    this.fetchChartData(this.props.activeSite, this.state.chartType)
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (
      this.props.activeSite !== nextProps.activeSite ||
      this.state.chartType !== nextState.chartType
    ) {
      this.fetchChartData(nextProps.activeSite, nextState.chartType)

      return false
    }

    return true
  }

  fetchChartData = (activeSite, chartType) => {
    const { fetchHistoricalData, fetchVisibilityData } = this.props
    const payload = {
      site: activeSite,
      now: moment.utc().format('YYYY-MM-DD HH:00:00'),
      type: TYPE_TRANSPARENCY,
    }

    if (chartType === CHART_TYPE_FORECAST) {
      payload.depth = 5
      fetchVisibilityData(payload)
    } else {
      fetchHistoricalData(payload)
    }
  }

  onChartTypeBtnClick = evt => {
    this.setState({
      chartType: evt.currentTarget.value,
    })
  }

  render() {
    const {
      chartData,
      visibilityChartData,
      intl: { formatMessage },
    } = this.props
    const { chartType, datasetIndex } = this.state
    const ChartView = this.componentList[chartType]
    const data =
      chartType === CHART_TYPE_FORECAST ? visibilityChartData : chartData
    const listData =
      chartType === CHART_TYPE_FORECAST
        ? visibilityChartData
        : chartData.get('dataView')
    const loader =
      chartType === CHART_TYPE_FORECAST
        ? visibilityChartData.get('loader')
        : chartData.get('loader')

    return (
      <>
        <ChartWrapper
          loader={loader}
          wrapTitle={formatMessage(messages.last12Days)}
          chartType={chartType}
          chartTypeChange={this.onChartTypeBtnClick}>
          <ChartView
            unit="Meters"
            datasetIndex={datasetIndex}
            chartData={data}
          />
        </ChartWrapper>
        <ListWrapper
          unit="Meters"
          icon={TransparencyWhite}
          chartType={chartType}
          dataView={listData}
        />
      </>
    )
  }
}

export default connect(
  state => ({
    activeSite: state.getIn(['profile', 'siteId']),
    chartData: state.getIn(['environmentMonitor', 'chartData']),
    visibilityChartData: state.getIn(['environmentMonitor', 'visibilityData']),
  }),
  {
    fetchHistoricalData,
    setListForecastData,
    fetchVisibilityData,
  },
)(injectIntl(Transparency))
